import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { COLUMNSHEADING } from '../constants';

// Column keys with no exportable data: the row action buttons and the
// daily-rank expand toggle.
const NON_EXPORTABLE_COLUMNS = ['actions', 'More'];

// The Tags column renders Primary + Secondary tags but is keyed on
// 'Secondary Tags', while the exporters build that cell from the 'Tags' heading.
const COLUMN_KEY_TO_EXPORT_HEADER: Record<string, string> = {
  'Secondary Tags': 'Tags'
};

/**
 * Resolves the ordered export headings for a table.
 *
 * `orderedColumns` holds the visible column keys in on-screen order, so the
 * file mirrors the user's "Arrange columns" layout. Without it we fall back to
 * the tab's static heading order minus the hidden columns.
 */
export const getExportHeaders = (
  id: string,
  hiddenColumns: CheckboxValueType[] = [],
  orderedColumns?: string[]
): string[] => {
  const tabHeadings = COLUMNSHEADING[id] ?? [];

  if (!orderedColumns?.length) {
    return tabHeadings.filter(
      name => !hiddenColumns.includes(name) && !NON_EXPORTABLE_COLUMNS.includes(name)
    );
  }

  // Keys with no matching heading have no cell-building rule in the generators.
  // This also drops the daily-rank date columns, which the generators append
  // themselves from the response data.
  const exportableHeadings = new Set(tabHeadings);

  const headers = orderedColumns
    .map(key => COLUMN_KEY_TO_EXPORT_HEADER[key] ?? key)
    .filter(
      name => !NON_EXPORTABLE_COLUMNS.includes(name) && exportableHeadings.has(name)
    );

  // Duplicates would collapse in the sheet and repeat cells in the PDF.
  return [...new Set(headers)];
};

export default getExportHeaders;
